export default __webpack_public_path__ + "static/media/RomitKumar.c393202f.jpg";